import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { createSelectorHook } from 'react-redux';
import { BreadcrumbsContext } from '~/providers/BreadcrumbsProvider';
import MainPage from '~/pages/MainPage';
import Content from '~/pages/SVA/Content';

export type SVAS = {
  codigo: number;
  sigla: string;
  nome: string;
  descricao: string;
  nomePortal: string;
  descricaoPortal: string;
  nomeApp: string;
  descricaoApp: string;
  tipoSVA: number;
  telefoneAtendimentoRH: string;
  siteAtendimentoRH: string;
  telefoneAtendimentoBeneficiario: string;
  siteAtendimentoBeneficiario: string;
  linkAppAndroid: string;
  linkAppIOS: string;
  beneficiosSVA: Array<Object>;
};

type RootState = {
  svas: Array<SVAS>;
};

export default function SVA() {
  const useSelector = createSelectorHook<RootState>();
  const breadcrumbs = useContext(BreadcrumbsContext);
  const svas: Array<SVAS> = useSelector(state => state.svas);
  const history = useHistory();

  useEffect(() => {
    if (!svas.length) {
      history.push('/home');
    }
  }, []);

  function setBreadcrumb(icon: string, label: string): void {
    breadcrumbs.setBreadcrumb({
      icon,
      label,
    });
  }

  useEffect(() => {
    setBreadcrumb('plus-circle', 'Serviços adicionais');
    return () => setBreadcrumb('', '');
  }, []);

  return (
    <>
      <MainPage>
        <Content svas={svas} />
      </MainPage>
    </>
  );
}
